import React from 'react';
import VerificationDetails from '../defaults/VerificationDetails';

export default (props) => {
  return (
    <VerificationDetails />
  );
}
